import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { BaseValidator } from '@tcm-modules/tcm-core.module';

@Directive({
    selector: '[atLeastOneValueRequired]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: AtLeastOneValueRequiredValidator, multi: true }
    ],
    standalone: false
})
export class AtLeastOneValueRequiredValidator extends BaseValidator implements OnChanges {

  @Input('atLeastOneValueRequired')
  allValues: any | any[];

  @Input()
  atLeastOneValueRequiredFieldNames: string[];

  @Input()
  isFormPristine: boolean;

  constructor() {
    super('atLeastOneValueRequired');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.allValues && changes.allValues.isFirstChange()) {
      return;
    }

    this._onChange();
  }

  protected getValidationResult(control: any) {

    let isControlValueEmpty;
    let isAllValuesEmpty;

    if (!this.isFormPristine) {
      if (!Array.isArray(control.value)) {
        isControlValueEmpty = !control.value;
        isAllValuesEmpty = !this.allValues || (this.allValues.length && this.allValues.every(y => !y));
      } else {
        isControlValueEmpty = !control.value.length;
        isAllValuesEmpty = !this.allValues.length || this.allValues.every(y => !y || (Array.isArray(y) && y.length == 0));
      }

      if (isControlValueEmpty && isAllValuesEmpty) {
        return this.buildValidationErrorResult({ fields: this.atLeastOneValueRequiredFieldNames.join(", ") });
      }
    }

    return null;
  }
}
